import React, { Dispatch, SetStateAction } from 'react';
import LandingCard from './landingCard';
import { NetworkType, RpcDetailType } from '../declaration';

interface Props {
  networkData: NetworkType[];
  setRpcDetail: (x: RpcDetailType) => void;
  setFlag: (x: boolean) => void;
  networkPayment: boolean;
  setNodeId: (x: string) => void;
  nodeID: string;
  setSessionsKey: React.Dispatch<React.SetStateAction<string>>;
  setCodes: Dispatch<SetStateAction<any>>;
  managedHosting: boolean;
}
const NodeCard = ({
  networkData,
  setRpcDetail,
  setFlag,
  networkPayment,
  setNodeId,
  nodeID,
  setSessionsKey,
  setCodes,
  managedHosting,
}: Props) => (
  <>
    <div
      className="alert alert-danger mb-1"
      id="fail"
      style={{ display: 'none' }}
      role="alert"
    >
      User currently doesn&apos;t have permission to perform this action
    </div>
    <div
      className="alert alert-danger mb-1"
      id="analyticsDiv"
      style={{ display: 'none' }}
      role="alert"
    >
      Analytics will start after node is in provisioning state
    </div>
    <div
      id="actionSuccess"
      className="alert alert-success mb-1"
      style={{ display: 'none' }}
      role="alert"
    >
      Action Performed
    </div>
    <div
      className="alert alert-danger mb-1"
      id="actionFail"
      style={{ display: 'none' }}
      role="alert"
    >
      Error performing action
    </div>
    <div>
      {networkData.length === 0 && (
        <div
          style={{
            color: '#ABB2B9',
            textAlign: 'center',
            fontSize: '20px',
            marginTop: '5%',
          }}
        >
          No Node Data
        </div>
      )}
      <section className="mx-2 mb-2 node-items">
        {networkData
          && networkData.length > 0
          && networkData.map((data, idx) => (
            <LandingCard
              key={`card-${idx.toString()}`}
              state={data.status}
              nodeName={data.node_name}
              endpoint={data.endpoint}
              cloudimage={data.cloud_id.toString()}
              region={data.region_id.toString()}
              networkId={data.network_id}
              node={data.node_id}
              redirectionUrl={data.redirectionUrl}
              setRpcDetail={setRpcDetail}
              setFlag={setFlag}
              networkPayment={networkPayment}
              setNodeId={setNodeId}
              nodeID={nodeID}
              setSessionsKey={setSessionsKey}
              setCodes={setCodes}
              managedHosting={managedHosting}
            />
          ))}
      </section>
    </div>
  </>
);
export default NodeCard;
